<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [frameworkComponents]="frameworkComponents"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    enableColResize
    enableSorting
    rowHeight="22"
    multiSortKey="ctrl"
    (mouseup)="onMouseUp($event)"
    (contextmenu)="handleClick($event)"
    [ngClass]="{'fullTempStyled': isFullTempStyle === true}"
  >
  </ag-grid-angular>
</div>
<bmark-client-orders-context-menu
  *ngIf="!embeddedTableMode"
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
>
</bmark-client-orders-context-menu>
<bfx-blotter-column-selector [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bfx-blotter-column-selector>
